import { render, staticRenderFns } from "./group_add.vue?vue&type=template&id=01397708&scoped=true&"
import script from "./group_add.vue?vue&type=script&lang=js&"
export * from "./group_add.vue?vue&type=script&lang=js&"
import style0 from "./group_add.vue?vue&type=style&index=0&id=01397708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01397708",
  null
  
)

export default component.exports